import { JuloUpdateEntry } from "./types"

export const dropInAndBookingInPlusMenuEntry: JuloUpdateEntry = {
  slug: "2026-10-29-drop-in-and-booking-in-plus-menu",
  date: "2026-10-29",
  title: "Ta emot drop-in och Skapa bokning finns under +",
  description:
    "**Ta emot drop-in** och **Skapa bokning** finns inte längre i sidomenyn och bland flikarna högst upp. Ni hittar dem i stället under **+**-knappen uppe i högra hörnet, som finns på alla sidor i Alfred.",
  images: [
    {
      src: "/julo-updates/2026-10-29-drop-in-and-booking-in-plus-menu/1-removed-tabs.png",
      alt: "Flikarna högst upp i Kalendern, där Ta emot drop-in och Skapa bokning är överkryssade och en pil pekar på +-knappen uppe i högra hörnet.",
    },
    {
      src: "/julo-updates/2026-10-29-drop-in-and-booking-in-plus-menu/2-plus-menu.png",
      alt: "+-knappen uppe i högra hörnet är öppnad och visar menyn med Ta emot drop-in och Skapa bokning.",
    },
  ],
  showPopupOncePerDevice: true,
}
